import React from 'react';
import { Server } from '../../server/server';
import AlertModal from '../modals/AlertModal';
import MessageModal from '../modals/MessageModal';
import PageEnvelope from '../elements/PageEnvelope';
import { Navigate } from 'react-router-dom';
import { getDeviceType, getOperatingSystem, isAppleDevice } from '../util/util';
import { getNotificationsPermission } from '../util/notifications';
import './SitePage.css';

interface SettingsPageState {
  message: string;
  alert: string;
  install: number;
  notifications: number;
  directOn: boolean;
  activityOn: boolean;
  notificationsOn: boolean;
  directOff: boolean;
  activityOff: boolean;
  notificationsOff: boolean;
}

class SettingsPage extends React.Component<{}, SettingsPageState> {
  public static pwa = null;
  protected badgeCount:number = 0;
  protected badgeInterval:any;

  constructor(props:{}) {
    super(props);

    this.state = {
      message: '',
      alert: '',
      install: -1,
      notifications: -1,
      directOn: false,
      activityOn: false,
      notificationsOn: false,
      directOff: false,
      activityOff: false,
      notificationsOff: false,
    };

    this.onLogin = this.onLogin.bind(this);
  }

  componentDidMount(): void {
    Server.account.addEventListener('login', this.onLogin);
    this.load();
  }

  componentWillUnmount() {
    Server.account.removeEventListener('login', this.onLogin);
  }

  load() {
    if(SettingsPage.pwa)
      this.setState({install: 0});
    else if(this.isInstalledOnDevice())
      this.setState({install: 1});
    else
      this.setState({install: -1});

    let device = getDeviceType();
    let permisson = getNotificationsPermission();
    let notifications = -1;
    if(device == 'desktop' && permisson) {
      let granted = (permisson == 'granted');
      let storage = window.localStorage.getItem('DeviceNotifications') == '1';
      notifications = granted && storage ? 1 : 0;
    }

    this.setState({notifications});

    if(notifications == 1)
      this.updateNotificationsFromStorage();
  }

  onLogin() {
    this.load();
  }

  onEnableDeviceNotifications() {
    if(!Server.account.isLoggedIn()) {
      this.setState({alert: 'You must be logged in to enable notifications.'});
      return;
    }

    let perm = getNotificationsPermission();
    if(!perm) return;

    if(perm == 'denied') {
      this.setState({alert: 'Notifications are currently blocked by the web browser.  You can unblock them in the browser settings for this website.'});
    }
    else if(perm == 'granted') {
      this.enableNotifications();
    }
    else {
      Notification.requestPermission().then((res)=>{
        this.enableNotifications();
      });
    }
  }

  getStorageItemState(item:string):boolean {
    return window.localStorage.getItem(item) == '1';
  }

  enableNotifications() {
    let storage = window.localStorage;
    storage.setItem('DeviceNotifications', '1');
    this.updateNotificationsFromStorage();
  }

  updateNotificationsFromStorage() {
    let storage = window.localStorage;
    let direct = storage.getItem('DeviceNotificationsDirect') ? storage.getItem('DeviceNotificationsDirect') == '1' : true;
    let activity = storage.getItem('DeviceNotificationsActivity') ? storage.getItem('DeviceNotificationsActivity') == '1' : true;
    let notifications = storage.getItem('DeviceNotificationsNotifications') ? storage.getItem('DeviceNotificationsNotifications') == '1' : true;

    this.setState({
      notifications: 1,
      directOn: direct,
      activityOn: activity,
      notificationsOn: notifications,
      directOff: !direct,
      activityOff: !activity,
      notificationsOff: !notifications,
    });

    storage.setItem('DeviceNotificationsDirect', direct ? '1' : '0');
    storage.setItem('DeviceNotificationsActivity', activity ? '1' : '0');
    storage.setItem('DeviceNotificationsNotifications', notifications ? '1' : '0');
  }

  onDisableDeviceNotifications() {
    window.localStorage.setItem('DeviceNotifications', '0');
    this.setState({
      notifications: 0,
      directOn: false,
      activityOn: false,
      notificationsOn: false,
      directOff: false,
      activityOff: false,
      notificationsOff: false
    })
  }

  isInstalledOnDevice() {
    // if ('getInstalledRelatedApps' in navigator) {
    //   (navigator as any).getInstalledRelatedApps().then(apps => {
    //     console.log(apps);
    //     if (apps.length > 0) {
    //       console.log('PWA is installed');
    //     } else {
    //       console.log('PWA is not installed');
    //     }
    //   });
    // }    

    if (window.matchMedia('(display-mode: standalone)').matches) 
      return true;
  
    return false;
  }

  onInstall() {
    SettingsPage.pwa.prompt();
    SettingsPage.pwa.userChoice.then((choiceResult: any) => {
      if (choiceResult.outcome === 'accepted') 
        this.setState({install: 1});
    });
  }

  onUninstall() {
    this.setState({alert: 'You can uninstall the app just like any other app on your device.'})
  }

  renderNotificationRow(title:string, onState:string, offState:string, storage:string) {
    let disabled = this.state.notifications != 1;

    let onStateOn = {};
    onStateOn[onState] = true;
    onStateOn[offState] = false;

    let offStateOn = {};
    offStateOn[offState] = true;
    offStateOn[onState] = false;

    let onChecked = this.state[onState] && Server.account.isLoggedIn();
    let offChecked = this.state[offState] && Server.account.isLoggedIn();

    return (
      <div className="site-page-row" style={{justifyContent: 'space-between'}}>
        <div>{title}</div>
        <div style={{paddingRight: '10px'}}>
          <input 
            className="site-toggle-button-on" 
            type="checkbox" 
            disabled={disabled} 
            checked={onChecked}
            value={this.state[onState]}
            onChange={(e:any)=>{
              this.setState(onStateOn);
              window.localStorage.setItem(storage, '1')
            }}
          />
          &nbsp;
          <input 
            className="site-toggle-button-off" 
            type="checkbox" 
            disabled={disabled}
            checked={offChecked}
            value={this.state[offState]}
            onChange={(e:any)=>{
              this.setState(offStateOn)
              window.localStorage.setItem(storage, '0')
            }}
          />
        </div>
      </div>
    )
  }

  render() {
    let device = getDeviceType();
    let isApple = isAppleDevice();
    
    let deviceNotificationButton = null;
    switch(this.state.notifications) {
      case -1:
        deviceNotificationButton = <button disabled={true}>Coming Soon</button>;
        break;
      case 0:
        deviceNotificationButton = <button onClick={()=>this.onEnableDeviceNotifications()}>Enable</button>;
        break;
      case 1:
        deviceNotificationButton = <button onClick={()=>this.onDisableDeviceNotifications()}>Disable</button>;
        break;
    }

    let installButton = null;
    switch(this.state.install) {
      case -1:
        installButton = <button disabled={true}>{this.isInstalledOnDevice() ? 'Already Installed' : 'Not Supported'}</button>;
        break;
      case 0:
        installButton = <button onClick={()=>this.onInstall()}>Install</button>;
        break;
      case 1:
        installButton = <button onClick={()=>this.onUninstall()}>Uninstall</button>;
        break;
    }

    return (
      <div className="site-page">
        <PageEnvelope width="500px">
          <div className="site-page-column">

            <div className="site-page-panel">
              <div className="site-page-column">
                <div className="site-page-row" style={{justifyContent: 'space-between'}}>
                  <div><b>{device == 'desktop' ? 'Desktop' : 'Mobile'} Notifications</b></div>
                  <div>{deviceNotificationButton}</div>
                </div>
                {this.renderNotificationRow('New Chat Messages', 'directOn', 'directOff', 'DeviceNotificationsDirect')}
                {this.renderNotificationRow('New Activity', 'activityOn', 'activityOff', 'DeviceNotificationsActivity')}
                {this.renderNotificationRow('New Notifications', 'notificationsOn', 'notificationsOff', 'DeviceNotificationsNotifications')}
              </div>
            </div>

            <div className="site-page-panel">
              <div className="site-page-column">
                <div className="site-page-row" style={{justifyContent: 'space-between'}}>
                  <div><b>{device == 'desktop' ? 'Desktop App' : 'Home Screen App'}</b></div>
                </div>

                {device == 'desktop' &&
                  <div>
                    Install this website as an app on your desktop where it will have it's own icon like any other app, run fullscreen without browser bars, and show notification counts.
                  </div>
                }

                {device != 'desktop' &&
                  <div>
                    You can add this website to your Home Screen where it will have it's own icon like any other app, run fullscreen without browser bars, and show notification counts.
                  </div>
                }

                {!isApple &&
                  <div>
                    {installButton}
                  </div>
                }

                {isApple &&
                  <div className="site-page-column">
                    <div>
                      Press the Share button on the top or bottom bar of the web browser:
                    </div>  
                    <div style={{textAlign: 'center'}}>
                      <img style={{borderRadius: '10px'}} src="/settings/share-button.png"/>
                    </div>  
                    <div>
                      Then select Add to Home Screen and follow the prompts:
                    </div>  
                    <div style={{textAlign: 'center'}}>
                      <img style={{borderRadius: '10px'}} src="/settings/add-to-home.png"/>
                    </div>  
                    <div>
                      <i>This feature is only available in the Safari web browser on iOS.</i>
                    </div>
                  </div>
                }

              </div>
            </div>

          </div>
        </PageEnvelope>

        <MessageModal message={this.state.message}/>
        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.setState({alert: ''})}/>
      </div>
    );
  }
}

export default SettingsPage;
